import React from 'react';
import dayjs from "dayjs";

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import {customRange, downloadBlob} from "../../utils/misc";
import retrievePermission from "../../utils/retrievePermission";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import PaymentCreateModal from "./PaymentCreateModal";
import CommonCallBackButton from "../Common/CommonCallBackButton";
import DeleteIcon from "@mui/icons-material/Delete";


class PaymentList extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            updatePermission: 0,
            createPermission: 0,
            deletePermission: 0,
            payments: null,
            filters: {
                year: new Date().getFullYear()
            },
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrievePayments();
        await this.retrievePermission();
    }

    async retrievePermission() {
        let updatePermission = await retrievePermission(
            'OppPaymentViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        let createPermission = await retrievePermission(
            'OppPaymentViewSet',
            'create',
            this.context.subscriberObject
        );
        let deletePermission = await retrievePermission(
            'OppPaymentViewSet',
            'destroy',
            this.context.subscriberObject
        );
        await this.setState(
            {
                updatePermission: updatePermission,
                createPermission: createPermission,
                deletePermission: deletePermission,
            }
        );
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrievePayments();
        }
    }

    async filterCallBack(filters){
        await this.setState({
            filters: filters
        });
        await this.retrievePayments();
    }

    async downloadCallBack() {
        const api = new BaseApi();
        const url = 'payment/list_download/';
        let params = {
            ordering: '-date'
        };
        params = {...params, ...this.state.filters};
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        downloadBlob(
            [response.data, ],
            'payments.csv'
        )
    }

    async retrievePayments() {
        const url = 'payment/';
        const api = new BaseApi();
        let params = {
            ordering: '-date'
        };
        params = {...params, ...this.state.filters};
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                payments: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    async delete(id) {
        const url = `payment/${id}/`;
        const api = new BaseApi();
        await api.delete(url);
        await this.retrievePayments()
    }

    render() {
        if (!this.state.payments) {
            return (<CircularProgress/>)
        }
        if (!this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    key={crypto.randomUUID()}
                    title={'Входящие платежи'}
                    url={'contract/payment'}
                    extraComponents={[
                        ...this.state.createPermission?[
                        {
                            component: PaymentCreateModal,
                            componentProps: {
                            },
                            callBack: this.retrievePayments.bind(this),
                        }
                        ]:[],
                    ]}
                    data={this.state.payments}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                    filterFields={[
                        {
                                name: 'year',
                                label: 'Год',
                                xs: 12,
                                sm: null,
                                md: null,
                                lg: null,
                                xl: null,
                                required: true,
                                default: this.state.filters.year,
                                type: 'select',
                                options: customRange(2015, new Date().getFullYear() + 2).map(value => (
                                    {value: value, label: value}
                                ))
                            },
                    ]}
                    filterCallBack={this.filterCallBack.bind(this)}
                    download={{
                        callBack: this.downloadCallBack.bind(this),
                    }}
                    fields={[
                        {
                            title: 'Компания',
                            name: 'opportunity.account.nameshort',
                            linkPattern: '/account/detail/:linkParam',
                            linkParam: 'opportunity.account.id',
                            visible: true,
                        },
                        {
                            title: 'Сделка',
                            name: 'opportunity.short_name',
                            linkPattern: '/opportunity/detail/:linkParam',
                            linkParam: 'opportunity.id',
                            visible: true,
                        },
                        {
                            title: 'Выручка',
                            name: 'revenue',
                            visible: true,
                        },
                        {
                            title: 'Дата',
                            name: 'date',
                            visible: true,
                            preProcess: (value) => (value?dayjs(value).format('DD.MM.YYYY'):value)
                        },
                        {
                            title: 'Подтверждено',
                            name: 'approval',
                            visible: true,
                            edit: {
                                permission: this.state.updatePermission,
                                fields: ['approval', ],
                                baseUrl: 'payment',
                                callBack: this.retrievePayments.bind(this),
                            },
                        },
                        {
                            title: 'Тип выручки',
                            name: 'opportunity.revenue_type.title',
                            visible: true,
                        },
                        {
                            title: '',
                            visible: this.state.deletePermission,
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                icon: DeleteIcon,
                                color: 'danger',
                            },
                            callBack: this.delete.bind(this),
                        },
                    ]
                    }
                />
            </Box>
        )
    }
}

export default withRouter(PaymentList)
